<template>
  <img
    class="mr-2"
    :src="schemeIcon"
    alt="scheme icon"
    :height="height"
    :width="width"
  />
</template>

<script>
export default {
  name: "SchemeIcon",
  props: {
    scheme: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "25",
    },
    height: {
      type: String,
      default: "20",
    },
  },
  computed: {
    schemeToLowerCase() {
      return this.scheme.toLowerCase();
    },
    schemeIcon() {
      const ICONS_SRC_URL = {
        asistencias: require("@/assets/icons/asistencias.svg"),
        asistencia: require("@/assets/icons/asistencias.svg"),
        siniestros: require("@/assets/icons/siniestros.svg"),
        reintegro: require("@/assets/icons/reintegro.svg"),
        fletes: require("@/assets/icons/fletes.png"),
        inmobiliaria: require("@/assets/icons/inmobiliaria.png"),
        corpo: require("@/assets/icons/corporativo.png"),
        "cliente-final": require("@/assets/icons/clientefinal.png"),
      };

      return ICONS_SRC_URL[this.schemeToLowerCase] || null;
    },
  },
};
</script>

<style>
</style>